import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgKey = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M17.874 3.22a.75.75 0 0 1 1.06 0l2.847 2.846a.75.75 0 1 1-1.061 1.06l-2.316-2.315-2.141 2.141 1.96 1.96a.75.75 0 1 1-1.061 1.06l-1.96-1.96-4.143 4.143a5.02 5.02 0 1 1-1.06-1.06l4.664-4.665.009-.008.008-.009zm-8.406 9.387a3.52 3.52 0 1 0-4.897 5.056 3.52 3.52 0 0 0 4.897-5.056"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgKey;
